import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation UpdateVariationImageMeta($id: ID!, $imageMeta: JSON!) {
    updateVariationImageMeta(id: $id, imageMeta: $imageMeta) {
      id
    }
  }
`;

export const updateVariationImageMeta = ({ id, imageMeta }) => {
  const variables = {
    id,
    imageMeta: JSON.stringify(imageMeta || {}),
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
